import React from "react";
import './Gallery.css';
import pic1 from './galleryImage/pic1.jpg';
import pic2 from './galleryImage/pic2.jpg';
import pic3 from './galleryImage/pic3.jpg';
import pic4 from './galleryImage/pic4.jpg';
import pic5 from './galleryImage/pic5.jpg';
import pic6 from './galleryImage/pic6.jpg';
import pic7 from './galleryImage/pic7.jpg';
import pic8 from './galleryImage/pic8.jpg';
import pic9 from './galleryImage/pic9.jpg';
import pic10 from './galleryImage/pic10.jpg';
import pic11 from './galleryImage/pic11.jpg';
import pic12 from './galleryImage/pic12.jpg';
import pic13 from './galleryImage/pic13.jpg';
import pic14 from './galleryImage/pic14.jpg';
import pic15 from './galleryImage/pic15.jpg';
import banner from './galleryImage/banner-gallery.jpeg'



const Gallery = () => {
  
  
  return (
  <>
  <section className="gallery-container">
  <img src={banner} type="image" alt="header" />
  <div className="container gallery-content">
    <div className="row">
      <div className="col-sm-6 content">
    <h1>Gallery</h1>
    </div>
  </div>
  </div>
</section>
  
  <section className="background">
<div className="container7">
    
    <div className="box">
      
      <div className="dream">
        <img src={pic1}/>
         <img src={pic2}/>
          <img src={pic3}/>
           <img src={pic4}/>
            <img src={pic5}/>
            
      </div>

        <div className="dream">
        <img src={pic6}/>
         <img src={pic7}/>
          <img src={pic8}/>
           <img src={pic9}/>
            <img src={pic10}/>
            
      </div>

        <div className="dream">
        <img src={pic11}/>
         <img src={pic12}/>
          <img src={pic13}/>
           <img src={pic14}/>
            <img src={pic15}/>
            
      </div>

      


    </div>
    <div className="btn">
      <a href="/Gallery">More</a>
    </div>
    </div>
    </section>
  </>
  );
};

export default Gallery;